export default {
	'translation.work': 'Work',
	'translation.assignments': 'Assignments',
	'translation.new_assignment': 'New Assignment',
	'translation.projects': 'Projects',
	'translation.contact_manager': 'Contact Manager',
	'translation.work_upload_tm': 'WorkUpload™',
	'translation.realtime': 'Realtime',
	'translation.talent': 'Talent',
	'translation.find_talent': 'Find Talent',
	'translation.recruiting': 'Recruiting',
	'translation.tests': 'Tests',
	'translation.surveys': 'Surveys',
	'translation.payments': 'Payments',
	'translation.overview': 'Overview',
	'translation.invoices': 'Invoices',
	'translation.requests': 'Requests',
	'translation.funds': 'Funds',
	'translation.add_funds': 'Add Funds',
	'translation.accounts': 'Accounts',
	'translation.reports': 'Reports',
	'translation.dashboard': 'Dashboard',
	'translation.new_report': 'New Report',
	'translation.all_reports': 'All Reports',
	'translation.analytics_dashboards': 'Dashboards',
	'translation.custom_reports': 'Reports',
	'translation.talent_profile': 'Talent Profile',
	'translation.my_profile': 'My Profile',
	'translation.my_talent': 'My Talent',
	'translation.talent_pools': 'Labor Clouds',
	'translation.my_work': 'My Work',
	'translation.find_work': 'Find Work',
	'translation.search': 'Search',
	'translation.search_my_assignments': 'Search my assignments',
	'translation.calendar': 'Calendar',
	'translation.ratings': 'Ratings',
	'translation.invitations': 'You have {0} pending Labor Cloud invitations',
	'translation.view_invitations': 'View Invitations',
	'translation.analytics': 'Analytics',
	'translation.talent_profile_op': 'Account',
	'translation.my_profile_op': 'Profile',
	'translation.tax_info': 'Tax Info',
	'translation.home': 'Home',
	'translation.orgstructure': 'Organizational Structures',
	'translation.withholding_orders': 'Withholding Orders'
};



// WEBPACK FOOTER //
// ./src/main/webapp/media/scripts/webpack/funcs/translation/lang_en.js